import { useEffect } from 'react';
import { faviconService } from '../../services/faviconService';

export const FaviconLoader = () => {
  useEffect(() => {
    const loadFavicon = async () => {
      try {
        const faviconData = await faviconService.getFavicon();
        if (faviconData && faviconData.url) {
          // Update favicon in the DOM
          const existingFavicon = document.querySelector("link[rel*='icon']");
          
          if (existingFavicon) {
            existingFavicon.setAttribute('href', faviconData.url);
            existingFavicon.setAttribute('type', faviconData.type);
          } else {
            const link = document.createElement('link');
            link.rel = 'icon';
            link.href = faviconData.url;
            link.type = faviconData.type;
            document.head.appendChild(link);
          }
        }
      } catch (error) {
        console.error('Error loading favicon:', error);
      }
    };

    loadFavicon();
  }, []);

  // This is a "headless" component that doesn't render anything
  return null;
};

export default FaviconLoader; 